import dayjs from 'dayjs';
import QRCode from 'qrcode';
import qs from 'qs';

export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
  return new Date(date).getTime() ? dayjs(date).format(format) : '';
}

export function dateValueOf(date) {
  // 日期格式转时间戳（豪秒）
  return dayjs(date).valueOf();
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    }
    else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

export function numberFormat(num) {
  const sizes = ['', '万', '亿', '万亿'];
  const k = 10000;
  if (num < k) {
    return num + '';
  }
  else {
    const i = Math.floor(Math.log(num) / Math.log(k));
    return ((num / Math.pow(k, i))).toFixed(0) + sizes[i];
  }
}
/**
 * @des 价格格式化
 * @param {number} price
 * @returns
 */
function formatPrice(price) {
  const _price = price ? parseFloat(price).toFixed(2) : 0;
  const result = String(_price).replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '/';
  return result;
}

/**
 * @des 价格默认值
 * @param {number} price
 * @returns
 */
function filterPrice(price, type = 1) {
  const text = { 1: '敬请期待', 2: '价格已包含' };
  return price ? '¥' + formatPrice(price) : text[type];
}

// 生成二维码
function drawQrCode({ url, el, width, height } = {}) {
  return new Promise((resolve, reject) => {
    QRCode.toDataURL(el, url, {
      width,
      height,
      margin: 1,
      x: 0,
      y: 0,
    }).then(() => {
      resolve();
    });
  });
}

// 拨打客服电话
export function customerServiceCall(tel = '4008108100') {
  window.location.href = `tel:${tel}`;
}
// 拨打客服电话
export function toBase64(imgUrl, fn) {
  // 一定要设置为let，不然图片不显示
  const image = new Image();
  // 解决跨域问题
  image.setAttribute('crossOrigin', 'anonymous');
  const imageUrl = imgUrl;
  image.src = imageUrl;
  // image.onload为异步加载
  image.onload = () => {
    var canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, image.width, image.height);
    var quality = 0.8;
    // 这里的dataurl就是base64类型
    // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
    const dataurl = canvas.toDataURL('', quality);
    fn(dataurl);
  };
}

export function Format(_date, _format) { // author: meizz
  _format = _format || 'yyyy-MM-dd hh:mm:ss';
  var o = {
    'y+': _date.getFullYear(),
    'M+': _date.getMonth() + 1, // 月份
    'd+': _date.getDate(), // 日
    'h+': _date.getHours(), // 小时
    'm+': _date.getMinutes(), // 分
    's+': _date.getSeconds(), // 秒
    'q+': Math.floor((_date.getMonth() + 3) / 3), // 季度
    'S': _date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(_format)) { _format = _format.replace(RegExp.$1, (_date.getFullYear() + '').substr(4 - RegExp.$1.length)); }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(_format)) { _format = _format.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))); }
  }
  return _format;
}

/**
 * 获取 url 参数
 * @param {string} url 'http://baidu.com?id=1&name=laowang'
 * @returns 出参 { id: 1, name: 'laowang' }
 */
export const getUrlParams = (url) => {
  const index = url.indexOf('?');
  if (index === -1) return {};
  const params = url.slice(index + 1);
  return qs.parse(params);
};

/**
 * 把base64转化成二进制文件
 * @param b64data 已编码数据
 * @returns {module:buffer.Blob}
 */
export const base64ToBlob = ({ b64data = '', contentType = '', sliceSize = 512 } = {}) => {
  return new Promise((resolve, reject) => {
    // 使用 atob() 方法将数据解码
    const byteCharacters = atob(b64data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = [];
      for (let i = 0; i < slice.length; i++) {
        byteNumbers.push(slice.charCodeAt(i));
      }
      // 8 位无符号整数值的类型化数组。内容将初始化为 0。
      // 如果无法分配请求数目的字节，则将引发异常。
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    let result = new Blob(byteArrays, {
      type: contentType,
    });
    result = Object.assign(result, {
      // jartto: 这里一定要处理一下 URL.createObjectURL
      preview: URL.createObjectURL(result),
      name: `图片示例.png`,
    });
    resolve(result);
  });
};

/**
 * blob对象转base64
 * @param {*} imgUrl
 * @param {*} name 文件名
 */
export const blobToBase64 = (imgUrl) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = imgUrl;
    image.onload = () => {
      // 构建canvas节点
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0, image.width, image.height);
      // 转换为Base64
      const imgBase64 = canvas.toDataURL();
      resolve(imgBase64);
    };
    image.onerror = (event) => {
      console.log('image.onerror===>', event);
      reject();
    };
  });
};

/**
 * 使async暂停一段时间
 * @param {number} timeout 暂停的时间，单位毫秒
 * @returns {Promise<unknown>}
 */
export const sleep = (timeout) => new Promise(resolve => setTimeout(resolve, timeout));

/**
 * 定时重试async函数fn直到成功resolve成功的值或者达到最大重试次数reject
 * @param {function(): Promise<unknown>} fn 需要执行的async函数
 * @param {number} maxTimes 最大重试次数
 * @param {number} timeout 每次重试间隔时间,单位毫秒,默认1000
 * @returns {Promise<unknown>}
 */
export const tryFn = (fn, maxTimes, timeout = 1000) => {
  return new Promise(async(resolve, reject) => {
    while (maxTimes) {
      try {
        const res = await fn();
        return resolve(res);
      }
      catch (e) {
        maxTimes--;
        await sleep(timeout);
      }
    }
  });
};
/**
 * @param {*} tel
 * @returns 电话号码脱敏
 */
export function geTel(tel) {
  if (String(tel).length !== 11) {
    return tel;
  }
  var reg = /^(\d{3})\d{4}(\d{4})$/;
  return (tel + '').replace(reg, '$1****$2');
}

export default {
  formatDate,
  dateValueOf,
  numberFormat,
  formatPrice,
  filterPrice,
  drawQrCode,
  Format,
  customerServiceCall,
  toBase64,
  base64ToBlob,
  blobToBase64,
  sleep,
  tryFn,
};
